module.exports = __webpack_public_path__ + "img/组 17652@2x.297d0725.png";